import { forwardRef } from 'react';
import Icon from 'components/Icon';

import './style.css';

const Input = forwardRef(
	(
		{
			placeHolder,
			onChange,
			onInput,
			onKeyPress,
			type = 'text',
			startIcon,
			endIcon,
			iconSize,
			colorIcon,
			name,
			label,
			value,
			defaultValue,
			pattern,
			multiple,
			hidden,
			accept,
			autoComplete = 'off',
			disabled = false,
			maxLength,
			onKeyUp,
		},
		ref
	) => {
		return (
			<div className="Input">
				{label && <label>{label}</label>}
				<div className="Input__wrapper">
					{startIcon && <Icon icon={startIcon} size={iconSize} color={colorIcon} />}
					<input
						placeholder={placeHolder}
						onChange={onChange}
						onInput={onInput}
						onKeyPress={onKeyPress}
						type={type}
						name={name}
						value={value}
						defaultValue={defaultValue}
						pattern={pattern}
						multiple={multiple}
						hidden={hidden}
						accept={accept}
						autoComplete={autoComplete}
						disabled={disabled}
						ref={ref}
						maxLength={maxLength}
						onKeyUp={onKeyUp}
					/>
					{endIcon && <Icon icon={endIcon} size={iconSize} color={colorIcon} />}
				</div>
			</div>
		);
	}
);
export default Input;
